import React, {PropTypes} from 'react';

const AcceptedAnswer = ({text}) => (
  <div className="header-tag header-tag--answered">
    <div className="header-tag__icon">
      <div className="icon-check icon-white icon-sm" />
    </div>
    <span className="header-tag__text">{text}</span>
  </div>
);

AcceptedAnswer.propTypes = {
  text: PropTypes.string.isRequired,
};

export default AcceptedAnswer;
